import React, {useCallback, useEffect, useRef, useState} from "react";
import moment from "moment-timezone";

export default function Timer(props) {
    const intervalRef = useRef(null);
    const [initialTimerValue, setInitialTimerValue] = useState();
    const [countDownTime, setCountDownTIme] = useState({
        minutes: "00",
        seconds: "00",
    });
    const [timeLeft, setTimeLeft] = useState(0);
    const [timerSet, setTimerSet] = useState(false);

    const getTimeDifference = (countDownTime) => {
        const currentTime = new Date().getTime();
        const timeDifference = countDownTime - currentTime;

        const minutes = Math.floor((timeDifference % (60 * 60 * 1000)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (60 * 1000)) / 1000);

        const paddedMinutes = minutes >= 10 ? minutes : `0${minutes}`;
        const paddedSeconds = seconds >= 10 ? seconds : `0${seconds}`;

        if (timeDifference <= 0) {
            setCountDownTIme({minutes: "00", seconds: "00"});
            setTimeLeft(0);

            // Clear interval
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        } else {
            setCountDownTIme({minutes: paddedMinutes, seconds: paddedSeconds});
            setTimeLeft(timeDifference / 1000);
        }
    };

    const startCountDown = useCallback(() => {
        try {
            //set timezone of expiry to SAST
            const expiryMoment = moment.tz(props?.expiry, "Africa/Johannesburg");

            if (expiryMoment.isValid()) {
                const countDownDateTime = expiryMoment.toDate();
                const maxTimer = 30 * 60; // 30 minutes in seconds
                const rawTimeLeft = Math.floor((countDownDateTime - new Date()) / 1000);
                const clampedTimeLeft = Math.min(maxTimer, Math.max(0, rawTimeLeft));

                setInitialTimerValue(maxTimer);
                setTimeLeft(clampedTimeLeft);
                getTimeDifference(countDownDateTime.getTime()); // Initial call

                // Clear existing interval if any
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                }

                // Start new interval
                intervalRef.current = setInterval(() => {
                    getTimeDifference(countDownDateTime.getTime());
                }, 1000);

                setTimerSet(true);
            }
        } catch (e) {
            setTimerSet(false);
        }
    }, [props?.expiry]);

    useEffect(() => {
        startCountDown();
    }, [startCountDown]);

    const fraction = timeLeft / initialTimerValue;
    const getProgressColor = () => {
        if (fraction > 0.5) return "#8BCD38"; // Green
        if (fraction > 0.2) return "#FFA800"; // Orange
        return "#F53636"; // Red
    };
    const radius = 10;
    const circumference = 2 * Math.PI * radius;
    const dashOffset = circumference * (1 - fraction);

    return (
        timerSet ? <div className="w-full flex justify-end">
            <svg
                viewBox="0 0 40 40"
                className="my-2 w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 transform"
            >
                {/* Background circle */}
                <circle
                    cx="16"
                    cy="16"
                    r={radius}
                    stroke="#b3b3b3"
                    strokeWidth="2"
                    fill="none"
                />
                {/* Progress circle */}
                <circle
                    cx="16"
                    cy="16"
                    r={radius}
                    stroke={getProgressColor()}
                    strokeWidth="2"
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={dashOffset}
                    strokeLinecap="round"
                    transform="rotate(-90 16 16)"
                />
                {/* Timer text inside the SVG */}
                <text
                    x="16"
                    y="16"
                    fill="#472977"
                    fontSize="6"
                    fontWeight="bold"
                    textAnchor="middle"
                    dominantBaseline="middle"
                >
                    {countDownTime?.minutes}:{countDownTime?.seconds}
                </text>
            </svg>
        </div> : null
    );
}